import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// UI
import { Typography } from '@components/typography';
import { Button } from '@components/button';
import { Icon, IconNames } from '@components/icon';
export interface ReferralCodeCardProps {
  code: string;
  referralUrl: string;
}
export const ReferralCodeCard: React.FC<ReferralCodeCardProps> = t0 => {
  const $ = _c(37);
  const {
    code,
    referralUrl
  } = t0;
  const [codeCopied, setCodeCopied] = React.useState(false);
  const [linkCopied, setLinkCopied] = React.useState(false);
  const codeCopyTimeoutRef = React.useRef(null);
  const linkCopyTimeoutRef = React.useRef(null);
  let t1;
  if ($[0] !== code) {
    t1 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(code);
        if (codeCopyTimeoutRef.current) {
          clearTimeout(codeCopyTimeoutRef.current);
        }
        setCodeCopied(true);
        codeCopyTimeoutRef.current = setTimeout(() => {
          setCodeCopied(false);
        }, 2500);
      } catch (t2) {
        const error = t2;
        console.error("Failed to copy:", error);
      }
    };
    $[0] = code;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopyCode = t1;
  let t2;
  if ($[2] !== referralUrl) {
    t2 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(referralUrl);
        if (linkCopyTimeoutRef.current) {
          clearTimeout(linkCopyTimeoutRef.current);
        }
        setLinkCopied(true);
        linkCopyTimeoutRef.current = setTimeout(() => {
          setLinkCopied(false);
        }, 2500);
      } catch (t3) {
        const error_0 = t3;
        console.error("Failed to copy:", error_0);
      }
    };
    $[2] = referralUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleCopyLink = t2;
  let t3;
  if ($[4] !== handleCopyLink || $[5] !== referralUrl) {
    t3 = async () => {
      const shareData = {
        title: "Get $50 off on Savvy",
        text: "Use my referral link and get $50 when you sign up on Savvy.",
        url: referralUrl
      };
      if (navigator.canShare && navigator.canShare(shareData)) {
        ;
        try {
          await navigator.share(shareData);
        } catch (t4) {
          const error_1 = t4;
          if ((error_1 as Error).name !== "AbortError") {
            await handleCopyLink();
          }
        }
      } else {
        await handleCopyLink();
      }
    };
    $[4] = handleCopyLink;
    $[5] = referralUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleShare = t3;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      if (codeCopyTimeoutRef.current) {
        clearTimeout(codeCopyTimeoutRef.current);
      }
      if (linkCopyTimeoutRef.current) {
        clearTimeout(linkCopyTimeoutRef.current);
      }
    };
    t5 = [];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  React.useEffect(t4, t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Typography variant="body2" component="p" className="mb-2">Your referral code</Typography>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== code) {
    t7 = <Typography variant="title5" component="p" className="tracking-wider">{code}</Typography>;
    $[10] = code;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = codeCopied ? IconNames.CHECK : IconNames.COPY;
  let t9;
  if ($[12] !== t8) {
    t9 = <Icon name={t8} className="w-5 h-5" />;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== handleCopyCode || $[15] !== t9) {
    t10 = <button type="button" onClick={handleCopyCode} className="text-primary-main/60 hover:text-primary-main transition-colors" aria-label="Copy referral code">{t9}</button>;
    $[14] = handleCopyCode;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <div className="bg-white border border-primary-main rounded-2xl px-6 py-4 shadow-md mb-6 text-center">{t6}<div className="flex items-center justify-center gap-2">{t7}{t10}</div></div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = linkCopied ? IconNames.CHECK : IconNames.COPY;
  let t13;
  if ($[20] !== t12) {
    t13 = <Icon name={t12} className="w-5 h-5" />;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = linkCopied ? "Copied!" : "Copy Link";
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = <span className="flex items-center justify-center gap-2">{t13}{t14}</span>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== handleCopyLink || $[26] !== t15) {
    t16 = <Button variant="outlined" size="lg" className="w-48 items-center justify-center rounded-full font-medium bg-white shadow-md hover:shadow-lg transition-shadow" onClick={handleCopyLink}>{t15}</Button>;
    $[25] = handleCopyLink;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="flex items-center justify-center gap-2"><Icon name={IconNames.SHARE} className="w-5 h-5" />Share</span>;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== handleShare) {
    t18 = <Button variant="filled" size="lg" className="w-48 items-center justify-center rounded-full font-medium shadow-md hover:shadow-lg transition-shadow" onClick={handleShare}>{t17}</Button>;
    $[29] = handleShare;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t16 || $[32] !== t18) {
    t19 = <div className="flex flex-col items-center sm:flex-row gap-3 justify-center">{t16}{t18}</div>;
    $[31] = t16;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t11 || $[35] !== t19) {
    t20 = <div className="max-w-sm mx-auto">{t11}{t19}</div>;
    $[34] = t11;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
};